import { ImageEditingType, QuestionEditingOptions } from '@examdojo/models/question-editor';
import {
  REFERENCE_QUESTION_REVIEW_TYPE_TO_REVIEW_PERMISSION,
  ReferenceQuestionReviewType,
  ReviewPermission,
} from '@examdojo/review';

export interface ReferenceQuestionReviewConfig extends QuestionEditingOptions {
  displayName: string;
  icon: string;
  urlPart: ReferenceQuestionReviewType;
  isSkippable: boolean;
  canStoreInBraintrust: boolean;
  allowJsonEditor: boolean;
  permission: ReviewPermission;
  showPreviousFeedback: ReferenceQuestionReviewType[];
}

export const REFERENCE_QUESTION_REVIEW_CONFIG: Record<ReferenceQuestionReviewType, ReferenceQuestionReviewConfig> = {
  [ReferenceQuestionReviewType.Question]: {
    displayName: 'Question',
    icon: 'square-question',
    urlPart: ReferenceQuestionReviewType.Question,
    isSkippable: false,
    allowQuestionStructureEditing: true,
    allowImageEditing: [ImageEditingType.Original],
    allowQuestionEditing: true,
    allowMarkschemeEditing: false,
    allowMcqEditing: true,
    allowMarkschemeStructureEditing: false,
    allowMcqStructureEditing: true,
    canStoreInBraintrust: false,
    allowJsonEditor: false,
    permission: REFERENCE_QUESTION_REVIEW_TYPE_TO_REVIEW_PERMISSION[ReferenceQuestionReviewType.Question],
    showPreviousFeedback: [],
    hideBadges: false,
    showMcqMetadata: true,
    hideMarkscheme: true,
  },
  [ReferenceQuestionReviewType.Markscheme]: {
    displayName: 'Markschemes',
    icon: 'clipboard-check',
    urlPart: ReferenceQuestionReviewType.Markscheme,
    isSkippable: true,
    allowImageEditing: [ImageEditingType.Original],
    allowQuestionEditing: true,
    allowMarkschemeEditing: true,
    allowMcqEditing: false,
    allowMarkschemeStructureEditing: true,
    allowMcqStructureEditing: false,
    canStoreInBraintrust: true,
    allowJsonEditor: false,
    showPreviousFeedback: [],
    permission: REFERENCE_QUESTION_REVIEW_TYPE_TO_REVIEW_PERMISSION[ReferenceQuestionReviewType.Markscheme],
    hideBadges: true,
  },
  [ReferenceQuestionReviewType.ExpertMarkscheme]: {
    displayName: 'Markschemes +',
    icon: 'check-to-slot',
    urlPart: ReferenceQuestionReviewType.ExpertMarkscheme,
    isSkippable: false,
    allowImageEditing: [ImageEditingType.Original],
    allowQuestionEditing: true,
    allowMarkschemeEditing: true,
    allowMcqEditing: false,
    allowMarkschemeStructureEditing: true,
    allowMcqStructureEditing: false,
    canStoreInBraintrust: true,
    allowJsonEditor: true,
    permission: REFERENCE_QUESTION_REVIEW_TYPE_TO_REVIEW_PERMISSION[ReferenceQuestionReviewType.ExpertMarkscheme],
    showPreviousFeedback: [ReferenceQuestionReviewType.Markscheme, ReferenceQuestionReviewType.ExpertMarkscheme],
    hideBadges: true,
  },
  [ReferenceQuestionReviewType.Image]: {
    displayName: 'Images',
    icon: 'image',
    urlPart: ReferenceQuestionReviewType.Image,
    isSkippable: true,
    allowImageEditing: [ImageEditingType.Generated],
    allowQuestionEditing: false,
    allowMarkschemeEditing: false,
    allowMcqEditing: false,
    allowMarkschemeStructureEditing: false,
    allowMcqStructureEditing: false,
    canStoreInBraintrust: false,
    allowJsonEditor: false,
    permission: REFERENCE_QUESTION_REVIEW_TYPE_TO_REVIEW_PERMISSION[ReferenceQuestionReviewType.Image],
    showPreviousFeedback: [],
    hideBadges: false,
  },
  [ReferenceQuestionReviewType.ExpertImage]: {
    displayName: 'Images +',
    icon: 'image-polaroid',
    urlPart: ReferenceQuestionReviewType.ExpertImage,
    isSkippable: false,
    allowImageEditing: [ImageEditingType.Generated],
    allowQuestionEditing: false,
    allowMarkschemeEditing: false,
    allowMcqEditing: false,
    allowMarkschemeStructureEditing: false,
    allowMcqStructureEditing: false,
    canStoreInBraintrust: false,
    allowJsonEditor: true,
    permission: REFERENCE_QUESTION_REVIEW_TYPE_TO_REVIEW_PERMISSION[ReferenceQuestionReviewType.ExpertImage],
    showPreviousFeedback: [ReferenceQuestionReviewType.Image, ReferenceQuestionReviewType.ExpertImage],
    hideBadges: false,
  },
};

export function getReferenceQuestionReviewConfig(mode: ReferenceQuestionReviewType): ReferenceQuestionReviewConfig {
  return REFERENCE_QUESTION_REVIEW_CONFIG[mode];
}

export function getAllReferenceQuestionReviewConfigs(): ReferenceQuestionReviewConfig[] {
  return Object.values(REFERENCE_QUESTION_REVIEW_CONFIG);
}
